import { render, staticRenderFns } from "./VotingTable.vue?vue&type=template&id=0655f8cb&scoped=true"
import script from "./VotingTable.vue?vue&type=script&lang=ts"
export * from "./VotingTable.vue?vue&type=script&lang=ts"
import style0 from "./VotingTable.vue?vue&type=style&index=0&id=0655f8cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655f8cb",
  null
  
)

export default component.exports